/* eslint-disable import/no-unresolved */
import { Input } from "@twilio-paste/core/input";
import { Label } from "@twilio-paste/core/label";
import { Box } from "@twilio-paste/core/box";
// import { TextArea } from "@twilio-paste/core/textarea";
// eslint-disable-next-line import/no-duplicates
import { useEffect, useState, FormEvent } from "react";
import { Button } from "@twilio-paste/core/button";
import { useDispatch, useSelector } from "react-redux";
// import { Text } from "@twilio-paste/core/text";
import { Select, Option } from "@twilio-paste/core/select";
// import { FilePicker, FilePickerButton } from "@twilio-paste/core/file-picker";
import { FilePicker, FilePickerButton } from "@twilio-paste/file-picker";
import { Spinner } from "@twilio-paste/core/spinner";
import { Toast, ToastContainer, Toaster, useToaster } from "@twilio-paste/toast";
import { Text } from "@twilio-paste/core/text";

import { addNotification, changeEngagementPhase, setRecentChatsExpanded, updatePreEngagementData } from "../../store/actions/genericActions";
import { AppState, EngagementPhase } from "../../store/definitions";
import { Header } from "../Header";
// import { notifications } from "../../notifications";
import { NotificationBar } from "../NotificationBar";
import { fieldStyles, formStyles, formButtonStyles, loadingStyles } from "../styles/PreEngagementFormPhase.styles";
import image from "../../assets/images/img2.png";
import contactBackend, { fileUpload } from "../../utils/contactBackend";
import file2Base64 from "../../utils/file2Base64";
import { sessionDataHandler } from "../../sessionDataHandler";
import { initSession } from "../../store/actions/initActions";
import { RecentChatsPanel } from "./RecentChatsPanel";

const skipEmailVerification = process.env.REACT_APP_SKIP_EMAIL_VERIFICATION === "true";

export const FormPhase = () => {
    const { Id, LastName, Email, CompanyName, Phone, FirstName, TWLO_WeChatId__c, query } =
        useSelector((state: AppState) => state.session.preEngagementData) || {};

    const [code, setCode] = useState("");

    const [formData, setFormData] = useState<{
        serviceType?: string;
        applicationDirection?: string;
        unapply?: string;
        feedback?: string;
        machineSerialNumber?: string;
        description?: string;
        file1?: File;
        file2?: File;
        file3?: File;
    }>({});

    const [flag, setFlag] = useState(0);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const toaster = useToaster();

    const [originalEmail, setOriginalEmail] = useState("");
    const [emailChanged, setEmailChanged] = useState(false);

    // 在组件加载时恢复保存的数据
    useEffect(() => {
        const savedPreEngagementData = sessionDataHandler.getPreEngagementData();
        console.log("组件加载时获取的缓存数据:", savedPreEngagementData);
        
        if (savedPreEngagementData) {
            // 额外检查：如果缓存有ID但没有邮箱，清除这个无效的缓存
            if (savedPreEngagementData.Id && !savedPreEngagementData.Email) {
                console.warn("检测到无效缓存：有ID但没有邮箱，清除缓存");
                const { Id: cachedId, ...dataWithoutId } = savedPreEngagementData;
                sessionDataHandler.savePreEngagementData(dataWithoutId);
                dispatch(updatePreEngagementData(dataWithoutId));
            } else {
                dispatch(updatePreEngagementData(savedPreEngagementData));
            }
        }
        // 主页默认收起聊天历史，避免进页就打 /recentChats 卡住首屏
        dispatch(setRecentChatsExpanded(false));
    }, [dispatch]);

    // 监听preEngagementData变化并保存到localStorage
    useEffect(() => {
        const preEngagementData = { Id, LastName, Email, CompanyName, Phone, FirstName, TWLO_WeChatId__c, query };
        console.log("数据变化，准备保存到缓存:", preEngagementData);
        
        // 如果有ID但其他必填字段缺失，清除ID（可能是无效的缓存）
        if (Id && (!Email || !LastName || !FirstName || !CompanyName || !Phone)) {
            console.warn("检测到无效的缓存数据：有ID但缺少必填字段，清除ID");
            const { Id: oldId, ...dataWithoutId } = preEngagementData;
            sessionDataHandler.savePreEngagementData(dataWithoutId);
        } else if (Email || LastName || FirstName || CompanyName || Phone || TWLO_WeChatId__c || query) {
            sessionDataHandler.savePreEngagementData(preEngagementData);
        }
    }, [Id, LastName, Email, CompanyName, Phone, FirstName, TWLO_WeChatId__c, query]);

    const formChange = (key: string, value: string) => {
        setFormData({ ...formData, [key]: value });
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        if (loading) return;

        try {
            setLoading(true);

            const files = [];

            // 保存 serviceType 到 Redux store
            dispatch(updatePreEngagementData({
                ServiceType: formData.serviceType
            }));

            if (formData.file1) {
                if (formData.file1.size / 1024 ** 2 >= 10) {
                    toaster.push({
                        message: "上传文件1大小超出10M",
                        variant: "warning",
                        dismissAfter: 1000 * 2
                    });
                    return;
                }
                // files.push({
                //     name: formData.file1.name,
                //     content: await file2Base64(formData.file1)
                // });
                const data = new FormData();
                data.append("json", JSON.stringify({ title: formData.file1.name, description: "" }));
                data.append("fileData", formData.file1);

                const res = await fileUpload<{ contentDocument: Record<string, any> }>(data);
                if (res?.contentDocument?.id) {
                    files.push(res.contentDocument.id);
                }
            }

            if (formData.file2) {
                if (formData.file2.size / 1024 ** 2 >= 10) {
                    toaster.push({
                        message: "上传文件2大小超出10M",
                        variant: "warning",
                        dismissAfter: 1000 * 2
                    });
                    return;
                }
                // files.push({
                //     name: formData.file2.name,
                //     content: await file2Base64(formData.file2)
                // });

                const data = new FormData();
                data.append("json", JSON.stringify({ title: formData.file2.name, description: "" }));
                data.append("fileData", formData.file2);

                const res = await fileUpload<{ contentDocument: Record<string, any> }>(data);
                if (res?.contentDocument?.id) {
                    files.push(res.contentDocument.id);
                }
            }

            if (formData.file3) {
                if (formData.file3.size / 1024 ** 2 >= 10) {
                    toaster.push({
                        message: "上传文件3大小超出10M",
                        variant: "warning",
                        dismissAfter: 1000 * 2
                    });
                    return;
                }
                // files.push({
                //     name: formData.file3.name,
                //     content: await file2Base64(formData.file3)
                // });

                const data = new FormData();
                data.append("json", JSON.stringify({ title: formData.file3.name, description: "" }));
                data.append("fileData", formData.file3);

                const res = await fileUpload<{ contentDocument: Record<string, any> }>(data);
                if (res?.contentDocument?.id) {
                    files.push(res.contentDocument.id);
                }
            }

            console.log("提交数据:", {
                contact: {
                    Id,
                    CompanyName,
                    Email,
                    FirstName,
                    LastName,
                    Phone,
                    Code: code,
                    TWLOWeChatId: TWLO_WeChatId__c
                },
                service: {
                    ServiceType: formData.serviceType,
                    ApplicationDirection: formData.applicationDirection,
                    unapply: formData.unapply,
                    feedback: formData.feedback,
                    MachineSerialNumber: formData.machineSerialNumber,
                    Description: formData.description
                },
                files
            });

            // 本地调试：跳过 Salesforce 验证码校验，直接发起 Twilio 会话
            if (skipEmailVerification) {
                console.warn("[dev] SKIP_EMAIL_VERIFICATION: bypass SF submit/verify");
                const data = await sessionDataHandler.fetchAndStoreNewSession({
                    formData: {
                        friendlyName: `${FirstName} ${LastName}`,
                        Email,
                        query,
                        service: {
                            ServiceType: formData.serviceType,
                            ApplicationDirection: formData.applicationDirection,
                            unapply: formData.unapply,
                            feedback: formData.feedback,
                            MachineSerialNumber: formData.machineSerialNumber,
                            Description: formData.description
                        }
                    }
                });

                await dispatch(
                    initSession({
                        token: data.token,
                        conversationSid: data.conversationSid,
                        name: `${FirstName || ""} ${LastName || ""}`.trim() || "Guest",
                        query: String(query || "")
                    }) as any
                );
                return;
            }

            const sessionFormData = {
                friendlyName: `${FirstName} ${LastName}`,
                Email,
                query,
                service: {
                    ServiceType: formData.serviceType,
                    ApplicationDirection: formData.applicationDirection,
                    unapply: formData.unapply,
                    feedback: formData.feedback,
                    MachineSerialNumber: formData.machineSerialNumber,
                    Description: formData.description
                }
            };

            // 须先过 SF 校验（验证码等），再开 Twilio 会话
            const resp = await contactBackend<{ code: number; message: string; comment?: Record<string, string> }>(
                "/submit",
                {
                    contact: {
                        Id,
                        CompanyName,
                        Email,
                        FirstName,
                        LastName,
                        Phone,
                        Code: code,
                        TWLOWeChatId: TWLO_WeChatId__c
                    },
                    service: {
                        ServiceType: formData.serviceType,
                        ApplicationDirection: formData.applicationDirection,
                        unapply: formData.unapply,
                        feedback: formData.feedback,
                        MachineSerialNumber: formData.machineSerialNumber,
                        Description: formData.description
                    },
                    files
                }
            );
            console.log("后端响应:", resp);

            if (resp.comment) {
                const data = await sessionDataHandler.fetchAndStoreNewSession({ formData: sessionFormData });
                // 绑定 conversation 不挡进窗
                contactBackend("/update", {
                    id: resp.comment.Id,
                    conversationId: data.conversationSid
                }).catch((updateErr) => console.warn("update conversationId failed", updateErr));

                await dispatch(
                    initSession({
                        token: data.token,
                        conversationSid: data.conversationSid,
                        name: `${FirstName || ""} ${LastName || ""}`.trim() || "Guest",
                        query: String(query || "")
                    }) as any
                );
            } else {
                toaster.push({
                    message: resp.message || "提交失败",
                    variant: "error",
                    dismissAfter: 1000 * 2
                });
            }
        } catch (err: any) {
            const errMsg = err.message || String(err);
            console.log("提交错误:", errMsg);
            console.log("错误详情:", err);
            
            // 检查是否是 "Contact not found" 错误
            if (errMsg.includes('Contact not found') || errMsg.includes('404') || errMsg.includes('not found')) {
                console.log("检测到Contact not found错误，开始清理缓存...");
                
                // 获取当前缓存
                const currentData = sessionDataHandler.getPreEngagementData() || {};
                console.log("当前缓存数据:", currentData);
                
                // 只保留邮箱，清除其他所有联系人信息
                const newData = {
                    Email: currentData.Email || "", // 保留邮箱
                    FirstName: "",
                    LastName: "",
                    CompanyName: "",
                    Phone: "",
                    TWLO_WeChatId__c: currentData.TWLO_WeChatId__c || "", // 保留微信ID
                    query: currentData.query || "",
                    // 确保ID被清除
                    Id: undefined
                };
                
                console.log("清理后的数据:", newData);
                
                // 更新 store
                dispatch(updatePreEngagementData(newData));
                
                // 保存到 localStorage
                sessionDataHandler.savePreEngagementData(newData);
                
                console.log("更新后的缓存:", sessionDataHandler.getPreEngagementData());
                
                // 提示用户重新填写
                toaster.push({
                    message: '您的联系人信息已过期，请重新获取验证码并提交',
                    variant: 'warning',
                    dismissAfter: 3000
                });
                
                // 重置邮箱验证状态
                setFlag(0);
                setEmailChanged(true);
                setCode(""); // 清空验证码输入框
                
                // 重要：这里需要返回，不执行后续的错误处理
                setLoading(false);
                return;
            }
            
            // 检查是否是验证码错误
            if (errMsg.includes('Verification code validation failed')) {
                toaster.push({
                    message: '验证码错误，请重新获取验证码',
                    variant: 'error',
                    dismissAfter: 3000
                });
                
                // 验证码错误，清空验证码
                setCode("");
                setFlag(0);
            } else {
                // 其他错误处理
                toaster.push({
                    message: errMsg,
                    variant: "error",
                    dismissAfter: 1000 * 2
                });
            }
            
            setLoading(false);
            dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
        } finally {
            setLoading(false);
        }
    };

    const getCode = async () => {
        if (flag) {
            return;
        }
        const input = document.getElementById("email") as HTMLInputElement;
        const valid = input.reportValidity();
        if (valid) {
            setFlag(1);
            setLoading(true);
            try {
                const resp = await contactBackend<{ code: number; message: string }>(`/email`, {
                    email: Email
                });
                if (resp.code === 200) {
                    setFlag(2);
                    toaster.push({
                        message: '验证码已发送，请查收邮箱',
                        variant: 'success',
                        dismissAfter: 3000
                    });
                } else {
                    setFlag(0);
                    toaster.push({
                        message: resp.message,
                        variant: "error",
                        dismissAfter: 1000 * 2
                    });
                }
            } catch (e) {
                // throw Error(`Something went wrong when trying to get an updated token: ${e}`);
                setFlag(0);
                toaster.push({
                    message: (e as Error).message,
                    variant: "error",
                    dismissAfter: 1000 * 2
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const load = async () => {
        const params = new URLSearchParams(window.location.search);
        console.log("number", params.get("number"));
        if (params.get("number")) {
            formData.machineSerialNumber = params.get("number") ?? undefined;
        }

        console.log("code", params.get("code"));
        if (params.get("code")) {
            try {
                console.log("TWLO_WeChatId__c", TWLO_WeChatId__c);
                console.log("URL中的code参数:", params.get("code"));
                
                // 不挡整页：后台换 openId/联系人，表单可先填写
                const result = await contactBackend<{
                    code: number;
                    message: string;
                    isSuccess: boolean;
                    data: Record<string, any>;  // 直接使用 data，不是 data.contact
                    Result?: string;
                    ErrorDetail?: string;
                    openId?: string;
                }>(`/wxid`, {
                    code: params.get("code"),
                    openId: TWLO_WeChatId__c
                });

                console.log("微信授权结果:", result);

                // 根据后端实际的返回格式进行调整
                if (result.code === 200 || result.isSuccess) {
                    // 方案1：如果后端返回的是原来的格式（数据在 result.data 中）
                    if (result.data && result.data.Id) {
                        const data = { 
                            ...result.data, 
                            CompanyName: result.data.TWLO_CompanyName__c 
                        };
                        Reflect.deleteProperty(data, "attributes");
                        
                        console.log("处理后的联系人数据（有Id）:", data);
                        
                        dispatch(updatePreEngagementData(data));
                    } 
                    // 方案2：如果后端返回的是新格式（数据在 result.data.contact 中）
                    else if (result.data?.contact && result.data.contact.Id) {
                        const contactData = { 
                            ...result.data.contact, 
                            CompanyName: result.data.contact.TWLO_CompanyName__c,
                            // 确保 Id 被正确映射
                            Id: result.data.contact.Id
                        };
                        Reflect.deleteProperty(contactData, "attributes");
                        
                        console.log("处理后的联系人数据（contact格式）:", contactData);
                        
                        dispatch(updatePreEngagementData(contactData));
                    }
                    // 方案3：只有 openId，没有联系人信息
                    else if (result.openId || result.data?.openId) {
                        const openId = result.openId || result.data.openId;
                        console.log("只有openId，没有联系人信息:", openId);
                        
                        dispatch(updatePreEngagementData({
                            TWLO_WeChatId__c: openId
                        }));
                    } else {
                        toaster.push({
                            message: "获取信息成功，但联系人数据格式异常",
                            variant: "warning",
                            dismissAfter: 1000 * 2,
                            setFocus: true
                        });
                    }
                } else {
                    toaster.push({
                        message: result.message || "获取微信信息失败",
                        variant: "error",
                        dismissAfter: 1000 * 2,
                        setFocus: true
                    });
                }
            } catch (e: any) {
                console.error("微信授权错误:", e);
                toaster.push({
                    message: e.message,
                    variant: "error",
                    dismissAfter: 1000 * 2,
                    setFocus: false
                });
            } finally {
                // 清掉 URL 上的 code，避免刷新重复换票
                try {
                    const url = new URL(window.location.href);
                    url.searchParams.delete("code");
                    url.searchParams.delete("state");
                    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
                } catch {
                    /* ignore */
                }
            }
        }
    };
    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        if (Email) {
            setOriginalEmail(Email);
        }
    }, [Email]);

    return (
        <>
            <Header />
            <NotificationBar />
            <Box>
                <img style={{ display: "block", width: "100vw" }} src={image} alt="" />
            </Box>

            <RecentChatsPanel email={Email} />
            
            <Box as="form" data-test="pre-engagement-chat-form" onSubmit={handleSubmit} {...formStyles}>
                <Box {...fieldStyles}>
                    <Label htmlFor="LastName" required>
                        姓
                    </Label>
                    <Input
                        type="text"
                        placeholder="请输入你的姓"
                        name="LastName"
                        data-test="pre-engagement-chat-form-name-input"
                        value={LastName}
                        onChange={(e) => dispatch(updatePreEngagementData({ LastName: e.target.value }))}
                        required
                        // disabled={Boolean(Id)}
                    />
                </Box>
                <Box {...fieldStyles}>
                    <Label htmlFor="FirstName" required>
                        名
                    </Label>
                    <Input
                        type="text"
                        placeholder="请输入你的名"
                        name="FirstName"
                        data-test="pre-engagement-chat-form-name-input"
                        value={FirstName}
                        onChange={(e) => dispatch(updatePreEngagementData({ FirstName: e.target.value }))}
                        required
                        // disabled={Boolean(Id)}
                    />
                </Box>
                <Box {...fieldStyles}>
                    <Label htmlFor="CompanyName" required>
                        单位/公司名称
                    </Label>
                    <Input
                        type="text"
                        placeholder="公司名称"
                        name="CompanyName"
                        value={CompanyName}
                        onChange={(e) => dispatch(updatePreEngagementData({ CompanyName: e.target.value }))}
                        required
                        // disabled={Boolean(Id)}
                    />
                </Box>
                <Box {...fieldStyles}>
                    <Label htmlFor="Phone" required>
                        电话
                    </Label>
                    <Input
                        type="text"
                        placeholder="请填写手机号"
                        name="Phone"
                        value={Phone}
                        onChange={(e) => dispatch(updatePreEngagementData({ Phone: e.target.value }))}
                        required
                        // disabled={Boolean(Id)}
                    />
                </Box>
                <Box {...fieldStyles}>
                    <Label htmlFor="Email" required>
                        邮箱
                    </Label>
                    <Input
                        id="email"
                        type="email"
                        placeholder="请输入你的邮箱"
                        name="Email"
                        data-test="pre-engagement-chat-form-email-input"
                        value={Email}
                        onChange={(e) => {
                            const newEmail = e.target.value;
                            dispatch(updatePreEngagementData({ Email: newEmail }));
                            if (originalEmail && newEmail !== originalEmail) {
                                setEmailChanged(true);
                                setFlag(0);
                                setCode("");
                            } else {
                                setEmailChanged(false);
                            }
                        }}
                        required
                        // disabled={Boolean(Id)}
                    />
                </Box>
                {(!Id || emailChanged) && !skipEmailVerification && (
                    <Box {...fieldStyles}>
                        <Label htmlFor="code" required>
                            邮箱验证码
                        </Label>
                        <Input
                            type="text"
                            placeholder="请输入邮箱验证码"
                            name="code"
                            data-test="pre-engagement-chat-form-email-input"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            required
                            insertAfter={
                                <Box
                                    as="button"
                                    type="button"
                                    onClick={getCode}
                                    variant="link"
                                    width="100px"
                                    border="none"
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 4
                                        }}
                                    >
                                        {flag === 0 && "获取验证码"}
                                        {flag === 1 && ["发送中"]}
                                        {flag === 2 && "已发送"}
                                    </div>
                                </Box>
                            }
                        />
                    </Box>
                )}

                <Box {...fieldStyles}>SERVICE REQUEST DETAILS</Box>
                <Box {...fieldStyles}>
                    <Label htmlFor="type" required>
                        服务类型
                    </Label>
                    <Select
                        id="type"
                        name="服务类型"
                        value={formData.serviceType}
                        onChange={(e) => formChange("serviceType", e.target.value)}
                        required
                    >
                        <Option value="">请选择</Option>
                        <Option value="障碍报修及技术类咨询">产品咨询、试剂耗材使用反馈、仪器故障报修等技术类</Option>
                        <Option value="装机、移机等非技术类咨询">产品询价、仪器装机、移机等非技术类</Option>
                        <Option value="服务态度投诉与建议">服务满意度反馈与建议</Option>
                    </Select>
                </Box>
                {formData.serviceType === "障碍报修及技术类咨询" && (
                    <Box {...fieldStyles}>
                        <Label htmlFor="apply" required>
                            技术类
                        </Label>
                        <Select
                            id="apply"
                            name="技术类"
                            value={formData.applicationDirection}
                            onChange={(e) => formChange("applicationDirection", e.target.value)}
                            required
                        >
                            <Option value="">请选择</Option>
                            <Option value="测序相关">测序相关</Option>
                            <Option value="芯片相关">芯片相关</Option>
                            <Option value="生物信息相关">生物信息相关</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </Box>
                )}
                {formData.serviceType === "装机、移机等非技术类咨询" && (
                    <Box {...fieldStyles}>
                        <Label htmlFor="unapply" required>
                            非技术类
                        </Label>
                        <Select
                            id="unapply"
                            name="非技术类"
                            value={formData.unapply}
                            onChange={(e) => formChange("unapply", e.target.value)}
                            required
                        >
                            <Option value="">请选择</Option>
                            <Option value="询价">询价</Option>
                            <Option value="装机">装机</Option>
                            <Option value="移机">移机</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </Box>
                )}
                {formData.serviceType === "服务态度投诉与建议" && (
                    <Box {...fieldStyles}>
                        <Label htmlFor="feedback" required>
                            反馈与建议
                        </Label>
                        <Select
                            id="feedback"
                            name="反馈与建议"
                            value={formData.feedback}
                            onChange={(e) => formChange("feedback", e.target.value)}
                            required
                        >
                            <Option value="">请选择</Option>
                            <Option value="公司流程">公司流程</Option>
                            <Option value="销售人员">销售人员</Option>
                            <Option value="售后专员">售后专员</Option>
                            <Option value="其他">其他</Option>
                        </Select>
                    </Box>
                )}
                <Box {...fieldStyles}>
                    <Label htmlFor="serial">机器序列号</Label>
                    <Input
                        type="text"
                        placeholder="机器序列号"
                        name="serial"
                        data-test="pre-engagement-chat-form-email-input"
                        value={formData.machineSerialNumber}
                        onChange={(e) => formChange("machineSerialNumber", e.target.value)}
                    />
                </Box>
                
                <Box {...formButtonStyles}>
                    <Button variant="primary" type="submit" data-test="pre-engagement-start-chat-button">
                        提交
                    </Button>
                </Box>
            </Box>
            
            <ToastContainer>
                {toaster.toasts.map((t, idx) => (
                    <Toast {...t} key={idx}>
                        {t.message}
                    </Toast>
                ))}
            </ToastContainer>
            {loading && (
                <Box {...loadingStyles} backgroundColor={"rgba(0,0,0,0.3)" as any}>
                    <Spinner title="Loading" color={"#ffffff" as any} decorative={false} />
                </Box>
            )}
        </>
    );
};